import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useGlobalContext } from "../Config";
import Calendar from "./Calendar";
import { formatDate } from "@fullcalendar/core/index.js";
import CierreTable from "../components/CierreTable";
import { ResumenPanel } from "../components/panel";
import moment from "moment";
import { ProgressSpinner } from "primereact/progressspinner";
import * as XLSX from "xlsx";

const Cierre = () => {
  const [filters2] = useState(null);
  const [loading2, setLoading2] = useState(true);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [fila, setFila] = useState(null);
  const [producto, setProducto] = useState(null);
  const { baseUrl, urlMedidores, urlDocumentos, urlCobranzas } = useGlobalContext();
  const estados = ["A", "E"];
  const usuarioId = sessionStorage.getItem("usuario_id");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [cabecera, setCabecera] = useState(null);
  const diaCobroFacturador = moment(cabecera?.cobro).format("YYYY-MM-DD");
  const diaFinFacturador = moment(cabecera?.fin).format("YYYY-MM-DD");
  const [valorUfUsada, setValorUfUsada] = useState(null);
  const [loadingPeriodo, setLoadingPeriodo] = useState(false);
  const [asignacionesCargadas, setAsignacionesCargadas] = useState(false);
  const estadoToIndexMap = {
    Inicio: 0,
    Ejecutado: 1,
    Validado: 2,
    Publicado: 3,
  };
  const activeIndex = estadoToIndexMap[cabecera?.estado] || 0;
  //const currentMonthYear = moment().format("MMMM YYYY");
  // const day20CurrentMonth = moment().date(20).format("D MMMM YYYY");
  const empresas = [
    { label: "ALTAMIRA", value: "ALTAMIRA" },
    { label: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];
  const items = [
    {
      label: "Inicio",
    },
    {
      label: "Ejecutado",
    },
    {
      label: "Validado",
    },
    {
      label: "Publicado",
    },
  ];
  const currentMonth = moment().format("MMMM");
  const pastMonth = moment().subtract(1, "month").format("MMMM");
  const [periodoOptions, setPeriodoOptions] = useState([]);
  const chartData = {
    labels: ["Agua", "Elect."],
    datasets: [
      {
        label: pastMonth,
        backgroundColor: "#42A5F5",
        data: [65, 59],
      },
      {
        label: currentMonth,
        backgroundColor: "#FFA726",
        data: [28, 48],
      },
    ],
  };
  const [selectedEmpresa, setSelectedEmpresa] = useState(empresas[0].value);
  const [monedaOptions, setMonedaOptions] = useState([]);
  const [monedaOptionsFetched, setMonedaOptionsFetched] = useState(false);
  const currentPeriodo = moment().format("YYYY-MM");
  const previousPeriodo = moment().subtract(1, "month").format("YYYY-MM");
  const getDatosEmpresaByNombre = async () => {
    try {
      const response = await fetch(
        `${baseUrl}getEmpresaByNombre?empresa=${selectedEmpresa}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setEmpresa(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  //---------------------------------
  //CALCULO DE VALOR UF EN EL MES ACTUAL
  //---------------------------------
  const fetchMonedaOptions = async () => {
    try {
      const response = await fetch(`${baseUrl}getAllMonedas`);

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setMonedaOptions(data.monedas);

      // Buscar la UF en la respuesta y guardarla
      const monedaUf = data.monedas.find((m) => m.codigo === "UF");
      if (monedaUf) {
        setValorUfUsada(monedaUf.tipoCambio);
      }
      setMonedaOptionsFetched(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //---------------------------------
  //CALCULO DE VALOR UF DEL MES SELECCIONADO
  //---------------------------------
  const fetchUfByPeriodo = async (periodo) => {
    const [year, month] = periodo.split("-");
    const url = `${baseUrl}getAllMonedasByMonthYear?mes=${parseInt(
      month
    )}&anio=${year}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch UF data");
      }
      const data = await response.json();
      setMonedaOptions(data.monedas);
      const monedaUf = data.monedas.find((m) => m.codigo === "UF");
      if (monedaUf) {
        setValorUfUsada(monedaUf.tipoCambio);
      } else {
        setValorUfUsada(null);
      }
      setMonedaOptionsFetched(true);
    } catch (error) {
      console.error("Error fetching UF data:", error);
      setValorUfUsada(null);
    }
  };

  //---------------------------------
  // DATA FACTURACION DEL PERIODO
  //---------------------------------
  const fetchPeriodoFacturacion = async (periodo) => {
    setLoadingPeriodo(true);
    setAsignacionesCargadas(false);
    const url = `${baseUrl}getPeriodoFacturacionByPeriodo?periodo=${periodo}&empresa=${selectedEmpresa}`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      //console.log("Asignaciones recibidas para el periodo seleccionado:", result.asignacionesPeriodo);
      setData(result.asignacionesPeriodo);
      setAsignacionesCargadas(true);
    } catch (error) {
      setError(error);
    } finally {
      setLoadingPeriodo(false);
    }
  };

  //---------------------------------
  // OBTENER CABECERA DE CIERRE
  //---------------------------------
  const fetchCabecera = async () => {
    const url = `${baseUrl}getCabeceraCierreByIdEmpresa?empresa=${selectedEmpresa}&periodo=${selectedPeriodo}`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setCabecera(result.cabecera);
    } catch (error) {
      setError(error);
    }
  };

  //---------------------------------
  //GESTIÓN DE PERIODOS
  //---------------------------------
function generatePeriodoOptions() {
    // ... existing code ...
    const today = moment();
    const day = today.date();

    // Fijo: permitir solo +1 mes futuro
    const mesesFuturos = 1;

    const months = [];
    const inicio = moment({ year: today.year(), month: 0, day: 1 });
    //const max = today.clone().startOf("month").add(day >= 10 ? mesesFuturos : 0, "months");
    const max = today.clone().startOf("month").add(day >= 1 ? mesesFuturos : 0, "months");
    let cursor = inicio.clone();
    while (cursor.isSameOrBefore(max, "month")) {
      const periodoValue = cursor.format("YYYY-MM");
      const periodoLabel = cursor
        .format("MMMM [de] YYYY")
        .replace(/^\w/, (c) => c.toUpperCase());
      months.push({ label: periodoLabel, value: periodoValue });
      cursor.add(1, "month");
    }

    setPeriodoOptions(months);
}

  //---------------------------------  
  //CARGA INICIAL DE DATOS
  //---------------------------------
  const [selectedPeriodo, setSelectedPeriodo] = useState(() => {const currentPeriodo = moment().format("YYYY-MM");return currentPeriodo;});
  const selectedPreviousPeriodo = moment(selectedPeriodo, "YYYY-MM").subtract(1, "month").format("YYYY-MM");
  const handleFetchAllData = async () => {
    setLoading(true);
    setLoadingPeriodo(true);
    setAsignacionesCargadas(false);
    try {
      await Promise.all([
        getDatosEmpresaByNombre(),
        fetchPeriodoFacturacion(selectedPreviousPeriodo),
        fetchUfByPeriodo(selectedPeriodo),
        generatePeriodoOptions(),
      ]);
      setAsignacionesCargadas(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
      setLoadingPeriodo(false);
    }
  };

  //---------------------------------  
  // EFECTO SECUNDARIO
  //---------------------------------
  useEffect(() => {
    if (selectedEmpresa) {
      handleFetchAllData();
      fetchCabecera(selectedEmpresa, selectedPeriodo);
    }
    if (selectedPeriodo) {
      fetchPeriodoFacturacion(selectedPreviousPeriodo);
      fetchUfByPeriodo(selectedPeriodo);
      fetchCabecera(selectedEmpresa, selectedPeriodo);
    }
  }, [selectedEmpresa, selectedPeriodo]);

  //---------------------------------  
  // FORMATOS Y ESTILOS
  //---------------------------------
  const desdeBodyTemplate = (rowData) => {
    return formatDate(rowData.desde);
  };

  const hastaBodyTemplate = (rowData) => {
    return formatDate(rowData.hasta);
  };

  const estadoBodyTemplate = (rowData) => {
    return (
      <span className={`customer-badge status-${rowData.estado}`}>
        {rowData.estado}
      </span>
    );
  };

  const estadoFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={estados}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        itemTemplate={statusItemTemplate}
        placeholder="Select a Status"
        className="p-column-filter"
        showClear
      />
    );
  };

  const statusItemTemplate = (option) => {
    return <span className={`customer-badge status-${option}`}>{option}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{textAlign: "center" }}>
        {!rowData.cerrada ? (
          <Button
            icon="pi pi-times"
            className="p-button-rounded p-button-danger p-button mr-2 mb-2 mt-2"
            onClick={() => {}}
            outlined
            tooltip="Sin Mediciones"
            tooltipOptions={{ position: 'top' }}
          />
        ) : (
          <Button
            icon="pi pi-check"
            className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
            outlined
            tooltip="Documento Completo"
            tooltipOptions={{ position: 'top' }}
          />
        )}
      </div>
    );
  };

  const buttonTemplate = (rowData) => {
    return (
      <div style={{textAlign: "center" }}>
        <Button
          // label="Reproceso"
          icon="pi pi-refresh"
          className="p-button p-button-rounded"
          style={{
            backgroundColor: "#66BB6A",
            borderColor: "#66BB6A",
            color: "white",
          }}
          disabled
          onClick={() => {}}
          outlined
          tooltip="Reprocesar"
          tooltipOptions={{ position: 'top' }}
          raised
        />
        
      </div>
    );
  };

  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="mm/dd/yy"
        placeholder="mm/dd/yyyy"
        mask="99/99/9999"
      />
    );
  };

  //---------------------------------
  //BOTON EJECUTAR CIERRE
  //---------------------------------
  const sumTotal = data?.reduce((acc, item) => acc + item.total, 0) ?? 0;
  const handleEjecutarCierre = () => {
    const confirmation = window.confirm(
      "¿Está seguro que desea ejecutar el cierre? (UF utilizada: " +
        valorUfUsada +
        " - " +
        periodoOptions.find((p) => p.value === selectedPeriodo).label +
        ")"
    );

    if (!confirmation) {
      return; // Exit the function if the user cancels
    }

    //let monedaUf = monedaOptions.find((m) => m.codigo === "UF");
    const url = `${baseUrl}ejecutarCierre?empresa=${encodeURIComponent(
      selectedEmpresa
    )}&idUsuario=${usuarioId}&periodo=${encodeURIComponent(
      selectedPreviousPeriodo
    )}&valorUf=${valorUfUsada}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.respuesta) {
          alert("Cierre ejecutado correctamente: " + data.mensaje);
        } else {
          alert("Error al ejecutar el cierre: " + data.mensaje);
        }
        handleFetchAllData();
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  //---------------------------------
  //BOTON VALIDAR CIERRE
  //---------------------------------
  const handleValidarCierre = () => {
    const confirmation = window.confirm(
      "¿Desea proceder con la validación del cierre de las asignaciones?"
    );

    if (!confirmation) {
      return; // Exit the function if the user cancels
    }
    const url = `${baseUrl}validarCierre?empresa=${encodeURIComponent(selectedEmpresa)}&idUsuario=${usuarioId}&periodo=${encodeURIComponent(previousPeriodo)}`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.respuesta) {
          alert("Cierre validado correctamente:", data.mensaje);
          window.location.reload(); // Recargar la página después de validar correctamente
        } else {
          alert("Error al validar el cierre:", data.mensaje);
        }
        handleFetchAllData();
      })

      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  //---------------------------------
  //BOTON REPROCESO
  //---------------------------------
  const handleReproceso = async () => {};

  //---------------------------------
  //BOTON PUBLICAR CIERRE
  //---------------------------------
  const handlePublicarCierre = async () => {

    const count = data.filter(item => item.cerrada === true && item.enviado === 0).length;
    const count1 = data.filter(item => item.cerrada  === false).length;
    const count2 = data.filter(item => item.enviado === 1).length;
    
    const confirmation = window.confirm(
      "¿Desea proceder con el envío masivo de las asignaciones a documentos?\n" +
      "Se enviarán solo las asignaciones con cierre aprobados (marcadas como ✓) son " + count + "\n" +
      "No se enviarán las asignaciones sin cierre, es decir, sin mediciones (marcadas como x) son: " + count1 + "\n" + 
      "No se enviarán las asignaciones que ya fueron enviadas son: " + count2
    );

    if (!confirmation) {
      return; 
    }

    try {
      setLoading(true);
      
      // Filtrar asignaciones que no han sido enviadas
      const asignacionesPendientes = data.filter(item => item.cerrada === true && item.enviado === 0);
      if (asignacionesPendientes.length === 0) {
        alert("No hay asignaciones pendientes para enviar.");
        setLoading(false);
        return;
      }

      // Procesar cada asignación y crear el payload masivo
      const payloadMasivo = [];
      
      for (const rowData of asignacionesPendientes) {

        // Obtener detalles de cobro
        const items = await fetch(
          `${baseUrl}getDetalleCobroByIdPeriodoFacturacion?idPeriodo=${rowData.id}`
        );
        if (!items.ok) {
          console.error(`Error al obtener detalles para asignación ${rowData.id}: ${items.status}`);
          continue;
        }

        const detalleData = await items.json();
        // Generar productos del payload
        const productos = detalleData.detallesCobro.map((detalle) => ({
          docCobro: detalle.docCobro,
          item: detalle.servicios === "arriendo" ? `Arriendo - ${detalle.item}` : detalle.item,
          total: parseFloat(
            (
              (detalle.item.includes("Agua") || detalle.item.includes("Electricidad")) &&
              parseFloat(detalle.consumo) > 0
                ? parseFloat(detalle.totalClp) / parseFloat(detalle.consumo)
                : parseFloat(detalle.totalClp)
            ).toFixed(2)
          ),
          cantidad: detalle.item.includes("Agua") || detalle.item.includes("Electricidad")
            ? detalle.consumo
            : 1,
          unidadMedida: detalle.unidadMedida,
          lectInicial: detalle.lectInicial,
          lectFinal: detalle.lectFinal,
          consolidado: detalle.consolidado,
          agrupamiento: detalle.agrupamiento
        }));

        // Agregar al payload masivo
        payloadMasivo.push({
          descripcionContrato: `${rowData.idCotizacion}`,
          rut: empresa.rut,
          rutFuncionario: empresa.rut,
          documento: { productos },
          periodo: moment(selectedPeriodo).format("YYYY-MM"),
          inicioPago: diaCobroFacturador,
          finPago: diaFinFacturador,
          fechaEmision: moment().format("YYYY-MM-DD"),
          fechaVencimiento: moment().add(5, "days").format("YYYY-MM-DD"),
          valorUf: valorUfUsada,
          rutContraparte: rowData.cliente.rut,
          razonSocialContraparte: rowData.cliente.razonSocial,
          giroContraparte: rowData.cliente.giro,
          comunaContraparte: rowData.domicilios[0]?.comuna
            ? rowData.domicilios[0].comuna
            : "No tiene comuna",
          codigoSucursal: 1,
          primer_mes: rowData.primer_mes,
        });
      }

      if (payloadMasivo.length === 0) {
        alert("No hay asignaciones válidas para enviar.");
        setLoading(false);
        return;
      }

      // Enviar payload masivo
      const myHeaders = new Headers();
      // myHeaders.append("Authorization", "Basic YWRtaW46a2VzcA==");
      myHeaders.append("Content-Type", "application/json");

      //formato total a 2 decimales
      let cuerpo = JSON.stringify(payloadMasivo);
      cuerpo = cuerpo.replace(/("total":)(\d+)(?=[,}])/g, '$1$2.0');

      const response = await fetch(
        `${urlDocumentos}guardarDetalleDocumento`,
        {
          method: "POST",
          headers: myHeaders,
          body: cuerpo,
          redirect: "follow",
          credentials: "include",
        }
      );

      if (response.ok) {
        // Marcar todas las asignaciones como enviadas
        for (const rowData of asignacionesPendientes) {
            await fetch(`${baseUrl}marcarEnvioAsignacion?idPeriodoFacturacion=${rowData.id}&idUsuarioSender=${sessionStorage.getItem("usuario_id")}`,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json"},
              }
            );
        }
      } else {
        const errorMessage = await response.text();
        alert(`Error al enviar las asignaciones: ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error en el proceso de envío masivo:", error);
      alert("Ocurrió un error durante el proceso de envío masivo.");
      
    } finally {
      setLoading(false);
      handleFetchAllData();
    }
  };

  //---------------------------------
  // FUNCION PARA FORMATEAR NUMEROS
  //---------------------------------
  const formatNumber = (amount) => {
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  //---------------------------------
  //DESCARGAR EXCEL
  //---------------------------------
  const handleDescargaExcel = () => {
      if (!data || data.length === 0) {
          alert("No hay datos para descargar.");
          return;
      }

      // Crear la hoja de resumen
      const resumenData = [
        ['RESUMEN DE FACTURACIÓN', '', '', '', ''],
        ['Periodo:', selectedPeriodo, '', 'UF Utilizada:', valorUfUsada],
        ['', '', '', '', ''],
        // ['PRODUCTOS Y SERVICIOS', 'Cantidad', 'Total UF', '', ''],
        // ['Arriendos', cantArriendo, totalArriendo.toFixed(3), '', ''],
        // ['Gastos Comunes', cantComun, totalComun.toFixed(3), '', ''],
        // ['Servicios', cantServicio, totalServicio.toFixed(3), '', ''],
        // ['Obras Civiles', cantCivil, totalCivil.toFixed(3), '', ''],
        // ['Total', '', (totalArriendo + totalServicio + totalCivil + totalComun).toFixed(3), '', ''],
        // ['', '', '', '', ''],
        ['DOCUMENTOS', 'Cantidad', 'Total UF', '', ''],
        ['Facturas Afectas', cantFacturaAfecta, totalFacturaAfecta.toFixed(3), '', ''],
        ['Facturas Exentas', cantFacturaExenta, totalFacturaExenta.toFixed(3), '', ''],
        ['Notas de Cobro', cantNotaCobro, totalNotaCobro.toFixed(3), '', ''],
        ['Total', '', (totalFacturaAfecta + totalFacturaExenta + totalNotaCobro).toFixed(3), '', ''],
      ];

      // Crear la hoja de detalle
      // const datosExcel = data.map((item, index) => {
      //   const arriendoUf = item.detalles.arriendo_uf
      //   const arriendoClp = item.detalles.arriendo_clp 

      //   const gastoComunUf = item.detalles.gasto_comun_uf 
      //   const gastoComunClp = item.detalles.gasto_comun_clp
        
      //   const servicioUf = item.detalles.servicio_uf
      //   const servicioClp = item.detalles.servicio_clp

      //   const obraUf = item.detalles.obra_uf
      //   const obraClp = item.detalles.obra_clp
      
      //   const totalUf = item.total ?? 0; 
      //   const totalClp = totalUf * valorUfUsada;

      //   return {
      //     "N°": index + 1,
      //     "Asignación": item.idCotizacion || "",
      //     "Nombre Fantasía": item.cliente?.razonSocial || "",
      //     "Arriendo (UF)": Number(arriendoUf.toFixed(3)),
      //     "Arriendo (CLP)": Math.round(arriendoClp),
      //     "Gasto Común (UF)": Number(gastoComunUf.toFixed(3)),
      //     "Gasto Común (CLP)": Math.round(gastoComunClp),
      //     "Servicios (UF)": Number(servicioUf.toFixed(3)),
      //     "Servicios (CLP)": Math.round(servicioClp),
      //     "Obras civiles (UF)": Number(obraUf.toFixed(3)),
      //     "Obras civiles (CLP)": Math.round(obraClp),
      //     "Total (UF)": Number(totalUf.toFixed(3)),
      //     "Total (CLP)": Math.round(totalClp)
      //   };
      // });

      // Crear datos para la hoja de documentos
      const documentosData = data.map((item, index) => {
        return {
          "N°": index + 1,
          "Asignación": item.idCotizacion || "",
          "Nombre Fantasía": item.cliente?.razonSocial || "",
          "Factura Afecta (UF)": item.detalles_total.f_afecta || 0,
          "Factura Afecta (CLP)": Math.round((item.detalles_total.f_afecta || 0) * valorUfUsada),
          "Factura Exenta (UF)": item.detalles_total.f_exenta || 0,
          "Factura Exenta (CLP)": Math.round((item.detalles_total.f_exenta || 0) * valorUfUsada),
          "Nota de Cobro (UF)": item.detalles_total.n_cobro || 0,
          "Nota de Cobro (CLP)": Math.round((item.detalles_total.n_cobro || 0) * valorUfUsada),
          "Total (UF)": (item.detalles_total.f_afecta || 0) + (item.detalles_total.f_exenta || 0) + (item.detalles_total.n_cobro || 0),
          "Total (CLP)": Math.round(((item.detalles_total.f_afecta || 0) + (item.detalles_total.f_exenta || 0) + (item.detalles_total.n_cobro || 0)) * valorUfUsada)
        };
      });

      // Crear datos para la hoja de contadorespor cliente
      const contadoresPorCliente = data.reduce((acc, item) => {
        const cotizacion = item.idCotizacion || "";
        
        if (!acc[cotizacion]) {
          acc[cotizacion] = {
            cantidadArriendos: 0,
            cantidadServicios: 0,
            cantidadGastoComun: 0,
            cantidadObrasCiviles: 0,
          };

        }
        
        // Usar los contadores que vienen en detalles
        acc[cotizacion].cantidadArriendos += item.detalles?.cant_arriendo || 0;
        acc[cotizacion].cantidadServicios += item.detalles?.cant_servicio || 0;
        acc[cotizacion].cantidadGastoComun += item.detalles?.cant_gasto_comun || 0;
        acc[cotizacion].cantidadObrasCiviles += item.detalles?.cant_obra_civil || 0;
        
        return acc;
      }, {});

      const contadoresData = Object.entries(contadoresPorCliente).map(([cliente, datos], index) => {
        return {
          "N°": index + 1,
          "Asignación": cliente,
          "Cantidad de Arriendos": datos.cantidadArriendos,
          "Cantidad de Servicios": datos.cantidadServicios,
          "Cantidad de Gastos Comunes": datos.cantidadGastoComun,
          "Cantidad de Obras Civiles": datos.cantidadObrasCiviles,
        };
      });

      // Crear el libro de Excel
      const libro = XLSX.utils.book_new();
      
      // Agregar la hoja de resumen
      const hojaResumen = XLSX.utils.aoa_to_sheet(resumenData);
      XLSX.utils.book_append_sheet(libro, hojaResumen, "Resumen");

      // // Agregar la hoja de detalle
      // const hojaDetalle = XLSX.utils.json_to_sheet(datosExcel);
      // XLSX.utils.book_append_sheet(libro, hojaDetalle, "Detalle");

      // Agregar la hoja de documentos
      const hojaDocumentos = XLSX.utils.json_to_sheet(documentosData);
      XLSX.utils.book_append_sheet(libro, hojaDocumentos, "Documentos");

      // Agregar la hoja de arriendos por cliente
      const hojaContadores = XLSX.utils.json_to_sheet(contadoresData);
      XLSX.utils.book_append_sheet(libro, hojaContadores, "Contadores");

      // Aplicar estilos
      const estilosResumen = {
        '!cols': [{ wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }],
        '!rows': [{ hpt: 30 }], // Altura de la primera fila
      };

      // const estilosDetalle = {
      //   '!cols': Array(Object.keys(datosExcel[0]).length).fill({ wch: 15 }),
      // };

      const estilosDocumentos = {
        '!cols': Array(Object.keys(documentosData[0]).length).fill({ wch: 15 }),
      };

      const estilosContadores = {
        '!cols': Array(Object.keys(contadoresData[0]).length).fill({ wch: 15 }),
      };

      hojaResumen['!cols'] = estilosResumen['!cols'];
      hojaResumen['!rows'] = estilosResumen['!rows'];
      // hojaDetalle['!cols'] = estilosDetalle['!cols'];
      hojaDocumentos['!cols'] = estilosDocumentos['!cols'];
      hojaContadores['!cols'] = estilosContadores['!cols'];

      // Agregar imagen del logo
      const logoImg = new Image();
      logoImg.src = '/logoCBQ.png';
      
      // Descargar el archivo
      XLSX.writeFile(libro, `Periodo_Facturacion_${selectedPeriodo}.xlsx`);
  };

  //---------------------------------
  //TOTALES y CONTADORES DE CATEGORIAS Y DOCUMENTOS EN ENCABEZADO
  //---------------------------------
  //DOCUMENTOS
  const totalFacturaExenta = data?.reduce((acc, item) => acc + (item.detalles_total?.f_exenta || 0), 0);
  const totalFacturaAfecta = data?.reduce((acc, item) => acc + (item.detalles_total?.f_afecta || 0), 0);
  const totalNotaCobro = data?.reduce((acc, item) => acc + (item.detalles_total?.n_cobro || 0), 0);

  const cantFacturaExenta = data?.reduce((acc, item) => acc + (item.detalles_total?.cant_factura_exenta || 0), 0);
  const cantFacturaAfecta = data?.reduce((acc, item) => acc + (item.detalles_total?.cant_factura_afecta || 0), 0);
  const cantNotaCobro = data?.reduce((acc, item) => acc + (item.detalles_total?.cant_nota_cobro || 0), 0);

  //totales por categoria
  const totalArriendo = data?.reduce((acc, item) => {
    const uf = item.detalles.arriendo_uf
    const clp = item.detalles.arriendo_clp / valorUfUsada
    return acc + (uf + clp);
  }, 0) || 0;

  const totalComun = data?.reduce((acc, item) => {
    const uf = item.detalles?.gasto_comun_uf
    const clp = item.detalles.gasto_comun_clp / valorUfUsada
    return acc + (uf + clp);
  }, 0) || 0;

  const totalCivil = data?.reduce((acc, item) => {
    const uf = item.detalles.obra_uf
    const clp = item.detalles.obra_clp / valorUfUsada
    return acc + (uf + clp);
  }, 0) || 0;

  const totalServicio = data?.reduce((acc, item) => {
    const uf = item.detalles?.servicio_uf
    const clp = item.detalles.servicio_clp / valorUfUsada
    return acc + (uf + clp);
  }, 0) || 0;

  //contadores por categoria
  const cantComun = data?.reduce((acc, item) => acc + (item.detalles?.cant_gasto_comun || 0), 0) || 0;
  const cantServicio = data?.reduce((acc, item) => acc + (item.detalles?.cant_servicio || 0), 0) || 0;
  const cantCivil = data?.reduce((acc, item) => acc + (item.detalles?.cant_obra_civil || 0), 0) || 0;
  const cantArriendo = data?.reduce((acc, item) => acc + (item.detalles?.cant_arriendo || 0), 0) || 0;
  //---------------------------------
  //DESPLIEGUE DE COMPONENTES
  //---------------------------------
  const estiloTexto = {display: "block",fontSize: "1rem",color: "#333", marginBottom: "0.5rem",};

  return (
    <>
      <div className="card" >
        <div style={{backgroundColor: "#fff",padding: "1rem",boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",borderRadius: "8px",}}>
          <h2 style={{color: "#333",textAlign: "center",marginBottom: "30px",}}>
            Ciclo de cierre
          </h2>

          {/*<StepByStep activeIndex={activeIndex} items={items}></StepByStep>*/}
          {/* totales de cabecera */}
          <div className="p-fluid formgrid grid mt-5">
            <div className="field col-12 md:col-6 flex align-items-center">
              <Dropdown
                id="empresa"
                value={selectedEmpresa}
                options={empresas}
                onChange={async (e) => {
                  setSelectedEmpresa(e.value);
                }}
                style={{ width: "48%", marginRight: "2%" }}
                placeholder="Seleccione Empresa"
                disabled={loading}
              />
              <Dropdown
                value={selectedPeriodo}
                options={periodoOptions}
                onChange={(e) => setSelectedPeriodo(e.value)}
                style={{ width: "48%" }}
                placeholder="Seleccione Periodo"
                disabled={loadingPeriodo}
              />
            </div>
            <div className="field col-12 md:col-6">
              <h5 style={{display: "block",fontSize: "1.2rem",color: "#333",marginBottom: "0.5rem",}}>
                Estado: <span style={{ color: "red" }}>{cabecera?.estado || "pendiente"}</span>
              </h5>
              <h4 style={{ margin: "0.5rem 0" }}>
                Recaudación esperada del periodo: {formatNumber(sumTotal) || "0,00"} UF
              </h4>
            </div>
          </div>

          <ResumenPanel
            estiloTexto={estiloTexto}
            cabecera={cabecera}
            asignacionesCargadas={asignacionesCargadas}
            formatNumber={formatNumber}
            totalServicio={totalServicio}
            cantServicio={cantServicio}
            totalFacturaExenta={totalFacturaExenta}
            cantFacturaExenta={cantFacturaExenta}
            totalComun={totalComun}
            cantComun={cantComun}
            totalNotaCobro={totalNotaCobro}
            cantNotaCobro={cantNotaCobro}
            totalCivil={totalCivil}
            cantCivil={cantCivil}
            totalArriendo={totalArriendo}
            totalFacturaAfecta={totalFacturaAfecta}
            valorUfUsada={valorUfUsada}
            cantArriendo={cantArriendo}
            cantFacturaAfecta={cantFacturaAfecta}
          />

          {/* div de botones */}
          <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-3">
                <Button
                  label="Ejecutar cierre"
                  icon={"pi pi-check"}
                  className="p-button p-button-secondary p-button-rounded"
                  style={{
                    width: "100%",
                    backgroundColor: "#FF4081",
                    borderColor: "#FF4081",
                    color: "white",
                  }}
                  onClick={async () => {
                    await handleEjecutarCierre();
                    handleFetchAllData();
                  }}
                  disabled={loading}
                  raised
                />
              </div>
              <div className="field col-12 md:col-3">
                <Button
                  label="Validar Cierre"
                  icon="pi pi-check-circle"
                  className="p-button p-button-secondary p-button-rounded"
                  style={{
                    width: "100%",
                    backgroundColor: "#42A5F5",
                    borderColor: "#42A5F5",
                    color: "white",
                  }}
                  onClick={async () => {
                    await handleValidarCierre();
                    handleFetchAllData();
                  }}
                  disabled={loading}
                  raised
                />
              </div>
              <div className="field col-12 md:col-3">
                <Button
                  label="Generar Doc. Venta"
                  icon="pi pi-upload"
                  className="p-button p-button-secondary p-button-rounded"
                  style={{
                    width: "100%",
                    backgroundColor: "#FFCA28",
                    borderColor: "#FFCA28",
                    color: "white",
                  }}
                  onClick={handlePublicarCierre}
                  disabled={loading}
                  raised
                />
              </div>
              <div className="field col-12 md:col-3">
                <Button
                  label="Ejecutar Reproceso"
                  icon="pi pi-refresh"
                  className="p-button p-button-secondary p-button-rounded"
                  style={{
                    width: "100%",
                    backgroundColor: "#66BB6A",
                    borderColor: "#66BB6A",
                    color: "white",
                  }}
                  onClick={handleReproceso}
                  disabled
                  raised
                  
                />
              </div>
          </div>
        </div>
      </div>
    

    
      {loadingPeriodo || !asignacionesCargadas ? (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      ) : data && data.length > 0 ? (
        <>
          <div className="col-12">
            <div className="card">
              <div className="p-col" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 style={{ marginBottom: "0" }}>Asignaciones</h5>
                <Button
                  label="Descargar"
                  icon="pi pi-download"
                  className="p-button-text p-button p-button-rounded"
                  style={{ marginLeft: "1rem" }}
                  onClick={handleDescargaExcel}
                  disabled={loading}
                  tooltip="Descargar cierre"
                  tooltipOptions={{ position: "top" }}
                  raised
                />
              </div>
              <div className="p-col">
                <span>
                  Ordenadas por defecto desde la más reciente a la más antigua.
                </span>
              </div>
              <CierreTable
                asignaciones={data}
                filters={filters2}
                loading={loading}
                desdeBodyTemplate={desdeBodyTemplate}
                dateFilterTemplate={dateFilterTemplate}
                hastaBodyTemplate={hastaBodyTemplate}
                estadoBodyTemplate={estadoBodyTemplate}
                estadoFilterTemplate={estadoFilterTemplate}
                actionBodyTemplate={actionBodyTemplate}
                setDisplayBasic={setDisplayBasic}
                displayBasic={displayBasic}
                fila={fila}
                setFila={setFila}
                producto={producto}
                setProducto={setProducto}
                baseUrl={baseUrl}
                urlMedidores={urlMedidores}
                monedaOptions={monedaOptions}
                buttonTemplate={buttonTemplate}
                currentPeriodo={selectedPeriodo}
                handleFetchAllData={handleFetchAllData}
                setLoading={setLoading}
                setData={setData}
                selectedEmpresa={selectedEmpresa}
                loading2={loading2}
                urlDocumentos={urlDocumentos}
                urlCobranzas={urlCobranzas}
                diaCobro={diaCobroFacturador}
                diaFin={diaFinFacturador}
                empresa={empresa}
                previousPeriodo={selectedPreviousPeriodo}
                periodoDeCobro={selectedPeriodo}
              />
            </div>
          </div>
        </>
    ) : (
      <p>No hay asignaciones para este período.</p>
    )}
    </>
  );
};

export default Cierre;
